import { createDataSelectors } from "@app/modules/app.reducers";
import { NumberSequence } from "@ea/shared_types/next/ea.types";

export const sequencesDataSelectors = createDataSelectors<NumberSequence>()("sequences");
